import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { Theme } from '../theme';
import Container from './container';
import Content from './content';

/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */
var Lozenge = /*#__PURE__*/memo(function (_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      testId = _ref.testId,
      _ref$isBold = _ref.isBold,
      isBold = _ref$isBold === void 0 ? false : _ref$isBold,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth;
  var props = {
    theme: theme,
    children: children,
    testId: testId,
    isBold: isBold,
    appearance: appearance,
    maxWidth: maxWidth
  };
  return /*#__PURE__*/React.createElement(Theme.Provider, {
    value: theme
  }, /*#__PURE__*/React.createElement(Theme.Consumer, props, function (themeTokens) {
    return /*#__PURE__*/React.createElement(Container, _extends({
      testId: testId
    }, themeTokens), /*#__PURE__*/React.createElement(Content, themeTokens, children));
  }));
});
Lozenge.displayName = 'Lozenge';
export default Lozenge;